import Route from 'cio/routes/base';
import Transition from '@ember/routing/-private/transition';
import { next } from '@ember/runloop';
import { inject as service } from '@ember/service';
import ImportModel, { ImportState } from 'cio/models/import';
import ReviewController, { AddToSegmentType } from 'cio/pods/imports/import/setup/review/controller';
import ConfirmChangesService from 'cio/services/confirm-changes';

export default class ReviewRoute extends Route {
  @service confirmChanges!: ConfirmChangesService;

  crumb() {
    return {
      name: 'Review',
      path: this.routeName,
    };
  }

  redirect(model: ImportModel) {
    if (model.state === ImportState.Failed) {
      return this.router.transitionTo('imports.import.setup.index', model);
    }

    return;
  }

  async setupController(controller: ReviewController, model: ImportModel, transition: Transition) {
    super.setupController(controller, model, transition);

    controller.fetchSegments.perform();

    let segment = await model.belongsTo('segment').load();

    if (segment != null) {
      controller.set('addToSegment', AddToSegmentType.Update);
      controller.set('formValues.segment' as any, {
        label: segment.name,
        value: segment.id,
      });
    } else {
      controller.set('formValues.segmentName' as any, model.name || `Import ${model.filename}`);
    }

    next(() => {
      // `set` call above can sometimes trigger a `did-change` call, so reset this to false since
      // the user didn't change it themselves
      controller.set('segmentOptionsDirty', false);
    });

    this.confirmChanges.register(controller, this);
  }

  resetController(controller: ReviewController, isExiting: boolean, transition: Transition) {
    super.resetController(controller, isExiting, transition);

    if (isExiting) {
      controller.reset();
    }
  }
}
